import React, { lazy } from "react";

const LazyCreateAudit = lazy(() => import("./CreateAudit"));

const CreateAudit = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyCreateAudit {...props} />;

export default CreateAudit;
